import { ReferencedEntity } from '@api';
import { AssetProperty } from '../../shared/services/api/model/assetProperty';
import { AssetTelemetry } from '../../shared/services/api/model/assetTelemetry';

export class AssetPropertiesStateModel {
    public propertyValues: AssetProperty[];
    public lastKnownTelemetryValues: AssetTelemetry[];
    public referencedEntities: ReferencedEntity[];
}

export const assetPropertiesDefaults = {
    name: 'assetProperties',
    defaults: {
        propertyValues: [] as Array<AssetProperty>,
        lastKnownTelemetryValues: [] as Array<AssetTelemetry>,
        referencedEntities: null as ReferencedEntity[],
    },
};
